var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styleMain},[_c('status-period-stopwatch',{attrs:{"start":_vm.dateStart,"end":_vm.dateEnd,"statusId":_vm.statusId},on:{"update":_vm.update}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }